import React from "react";
import { Card, Button } from "react-bootstrap";
import { FiGift } from "react-icons/fi";

export default function BirthdaysCard(){

return(

<Card className="flex-fill birthday-card">

<Card.Header className="d-flex justify-content-between  card-header-custom">

<h5>Birthdays</h5>

<Button variant="light" size="sm">View All</Button>

</Card.Header>

<Card.Body>

<h6>Today</h6>

<div className="birthday active">

<img src="/assets/img/users/user-38.jpg"/>

<div>

<h6>Andrew Jermia</h6>

<p>IOS Developer</p>

</div>

<Button variant="light" size="sm">
<FiGift/> Send
</Button>

</div>

<h6 className="mt-3">Tomorrow</h6>

<div className="birthday">

<img src="/assets/img/users/user-10.jpg"/>

<div>

<h6>Mary Zeen</h6>

<p>UI/UX Designer</p>

</div>

<Button variant="light" size="sm">
<FiGift/> Send
</Button>

</div>

<div className="birthday">

<img src="/assets/img/users/user-09.jpg"/>

<div>

<h6>Antony Lewis</h6>

<p>Android Developer</p>

</div>

<Button variant="light" size="sm">
<FiGift/> Send
</Button>

</div>

<h6 className="mt-3">25 Jan 2025</h6>

<div className="birthday">

<img src="/assets/img/users/user-12.jpg"/>

<div>

<h6>Doglas Martini</h6>

<p>.Net Developer</p>

</div>

<Button variant="light" size="sm">
<FiGift/> Send
</Button>

</div>

</Card.Body>

<style>
{`
birthday-card{
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;

box-shadow:0 2px 5px rgba(0,0,0,0.05);
}


.birthday{
display:flex;
align-items:center;
justify-content:space-between;
border:1px dashed #ddd;
padding:10px;
border-radius:6px;
margin-bottom:12px;
}
     .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}


.birthday img{
width:40px;
height:40px;
border-radius:50%;
margin-right:10px;
}

.birthday div{
flex:1;
margin-left:10px;
}

.birthday h6{
margin:0;
font-size:16px;
}

.birthday p{
margin:0;
font-size:13px;
color:#777;
}

.birthday.active{
background:#0d5c63;
color:white;
}

`}
</style>

</Card>

)

}